/**
 * Global application state
 */

import type { VmListItem } from './api/types.js';

// Global state
export let suspendUpdates = false;
export let resourceCallsDisabled = false;
export let vms: VmListItem[] = [];
export let longPollHash = '';

// Setters for mutable globals
export function setSuspendUpdates(value: boolean): void {
  suspendUpdates = value;
}

export function setResourceCallsDisabled(value: boolean): void {
  resourceCallsDisabled = value;
}

export function setVms(value: VmListItem[]): void {
  vms = value;
}

export function setLongPollHash(value: string): void {
  longPollHash = value;
}

/**
 * Get VM by ID from global vms array
 */
export function getVmById(id: number): VmListItem | undefined {
  return vms.find(vm => vm.id === id);
}

/**
 * Get VM by name from global vms array
 */
export function getVmByName(name: string): VmListItem | undefined {
  return vms.find(vm => vm.name === name);
}
